import {
  isFunction,
  bridgeCall,
  isAndroid,
  withFusion,
  isPassenger,
  isEnterprise,
  isMini,
  isKflower,
  isHmPassenger,
  isBusDriver,
  isOil
} from '../util'

import FusionObj from './fusion'
import packageJson from '../../package.json'

export default class Fusion {
  constructor (modules, noDefault) {
    this.modules = modules || []
    this.__version__ = Fusion.__version__
    if (this.modules.length === 0 && !noDefault) {
      if (isPassenger) {
        this.modules = ['DidiBridgeAdapter', 'CarhailingModule', 'TraceModule']
      }
      if (isKflower) {
        this.modules = ['BridgeAdapter', 'TraceModule']
      }
      if (isEnterprise) {
        this.modules = ['CommonModule', 'TraceModule']
      }
      if (isMini) {
        this.modules = ['MiniBridge', 'TraceModule']
      }
      if (isHmPassenger) {
        this.modules = ['BlackHorseCommonBridge', 'TraceModule']
      }
      if (isBusDriver) {
        this.modules = ['DefaultBridgeModule']
      }
      if (isOil) {
        this.modules = ['DidiBridgeAdapter']
      }
    }

    Fusion.validateAndMount()
    this.fetchJSModules()
  }

  static get __version__ () {
    return packageJson.version
  }

  /**
   * 用于校验是否存在不同版本Fusion
   * 对比Global上的实例与Fusion上的实例是否是同一个
   */
  static validateAndMount () {
    // 不存在Fusion，直接挂
    if (!window.Fusion) {
      window.Fusion = FusionObj
    } else {
      if (window.Fusion.globalInstance) {
        // 2.0.0+版本Fusion，兼容
        return
      } else {
        // 不兼容的Fusion，抛错
        throw new Error('已经存在低版本Fusion')
      }
    }
  }

  /**
   * 注册模块
   *
   * @param      {array}  modules    模块对象列表
   */
  registerModules (modules) {
    window.Fusion.globalInstance.modules = modules

    for (let i in modules) {
      const moduleName = modules[i].module
      let methods = modules[i].methods
      if (this.modules.indexOf(moduleName) >= 0) {
        for (let j in methods) {
          let methodName = methods[j]
          if (!this[methodName]) {
            this[methodName] = this.invokeNative(moduleName, methodName)
          } else {
            console.error(`主模块${moduleName}中的方法名${methods}与Fusion中已有属性存在命名冲突，请检查！`)
          }
        }
      } else {
        if (!this[moduleName]) {
          this[moduleName] = {}
        } else {
          console.error(`模块${moduleName}的模块名与Fusion中已有属性存在命名冲突，请检查！`)
          continue
        }
        for (let j in methods) {
          let methodName = methods[j]
          this[moduleName][methodName] = this.invokeNative(moduleName, methodName)
        }
      }
    }
  }

  static getRegisteredModules () {
    return window.Fusion.globalInstance.modules
  }

  /**
   * 获取客户端内置模块
   *
   */
  fetchJSModules () {
    if (window.Fusion.globalInstance.modules) {
      this.registerModules(window.Fusion.globalInstance.modules)
    } else {
      if (isAndroid) {
        if (withFusion) {
          let message = JSON.stringify({
            fusion: 'loadJSModules'
          })
          let results = window.prompt(message)
          try {
            results = JSON.parse(results)
            this.registerModules(results)
          } catch (e) {
          }
        }
      } else {
        let self = this
        if (window.loadJSModules) {
          window.loadJSModules(function (modules) {
            self.registerModules(modules)
          })
        }
      }
    }
  }

  /**
   * JS 调用 Native
   *
   * @param      {string}  module  模块名
   * @param      {string}  method  方法名
   */
  invokeNative (module, method) {
    return function (...args) {
      const callbackId = window.Fusion.globalInstance.callbackId
      for (var i = 0; i < args.length; i++) {
        if (isFunction(args[i])) {
          args = args.slice(0, +i + 1)
          window.Fusion.globalInstance.callbacks[callbackId] = args[i]
          args[i] = callbackId
          ++window.Fusion.globalInstance.callbackId
          break
        }
      }
      bridgeCall('invokeNative', module, method, args)
    }
  }
}
